import { Wrapper } from '@klv/utils/wrapper';
import Buttons from '@klv/molecules/buttons';
import MixedMedia from '@klv/molecules/mixed-media';
import { generateClassName } from '@klv/shared/utils/functions';

import * as styles from './styles/slide.module.scss';

import type { ISlideProps } from '../../types';

export const Slide = ({
  slide,
  backgroundType,
  customPadding = { customPaddingBottom: 'xs', customPaddingTop: 'xs' }
}: ISlideProps) => {
  return (
    <div className={styles.slide}>
      <Wrapper 
        className={styles.slideWrapper}
        contained={true} 
        inlinePadding={true}
        customPadding={customPadding}
      >
        <div className={styles.slideContent}>
          {slide.headline && (
            <h2
              className={generateClassName(['h1', 'semibold', styles.headline])}
              dangerouslySetInnerHTML={{ __html: slide.headline }}
            />
          )}
          {slide.subtext && (
            <p 
              className={generateClassName(['p1', styles.subtext])}
              dangerouslySetInnerHTML={{ __html: slide.subtext }}
            />
          )}
          <Buttons
            className="mdPaddingBottom"
            buttons={slide.buttons}
            buttonColor={backgroundType === 'light' ? 'dark' : 'light'}
            variants={['secondary', 'tertiary']}
          />
          {slide.mixedMedia && (
            <div className={styles.mixedMedia}>
              <MixedMedia mixedMedia={slide.mixedMedia} />
            </div>
          )}
          <div className={generateClassName([styles.exploreLinks])}>
            {slide.exploreLabel && <span className="p1">{slide.exploreLabel}</span>}
            {slide.exploreLinks && slide.exploreLinks.length > 0 && (
              <>
                {slide.exploreLinks.map((link, linkIndex) => (
                  <a 
                    className="p1 semibold"
                    key={linkIndex}
                    href={link.url}
                    target={link.openInNewTab ? '_blank' : '_self'}
                    rel={link.openInNewTab ? 'noopener noreferrer' : undefined}
                  >
                    {link.label}
                  </a>
                ))}
              </>
            )}
          </div>
        </div>
      </Wrapper>
    </div>
  );
};
